import { useCallback } from 'react';

interface IInput {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  width?: number | string;
  textAlign?: 'left' | 'center' | 'right';
  suffix?: string;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  style?: any;
  className?: string;
  fontSize?: string;
  type?: 'text' | 'password' | 'date' | 'time' | 'number' | 'email';
  disabled?: boolean;
  maxLength?: number;
}

/**
 * @author taulmax
 * @date 2024.10.09
 * @description Input 공통 컴포넌트
 */
const Input = ({
  value,
  onChange,
  onBlur,
  width = 300,
  textAlign = 'center',
  suffix,
  placeholder,
  inputRef,
  style,
  className,
  fontSize,
  type = 'text',
  disabled = false,
  maxLength,
}: IInput) => {
  // Focus Event
  const onFocusInput = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    e.target.parentElement?.classList.add('active');
  }, []);

  // Blur Event
  const onBlurInput = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    e.target.parentElement?.classList.remove('active');
  }, []);

  // 숫자 입력 시 마우스 휠로 값이 변경되지 않도록 방지
  const onWheelInput = useCallback((e: React.WheelEvent<HTMLInputElement>) => {
    if (type !== 'number') return;
    const target = e.target as HTMLInputElement;
    if (document.activeElement === target) {
      target.blur();
    }
  }, [type]);

  return (
    <div
      style={{ width, ...style }}
      className={`!relative ${className ? className : ''} ${
        disabled ? '!opacity-50' : ''
      }`}
    >
      <input
        ref={inputRef}
        style={{ textAlign, fontSize }}
        value={value}
        onChange={onChange}
        onFocus={onFocusInput}
        onBlur={(e) => { onBlurInput(e); onBlur && onBlur(e); }}
        onWheel={onWheelInput}
        placeholder={placeholder}
        className="!w-full !px-3 !py-2 !border !border-gray-200 !rounded-md !text-sm !font-normal !text-gray-900 placeholder:!text-gray-400 placeholder:!text-sm placeholder:!font-normal focus:!outline-none focus:!border-blue-500 disabled:!bg-gray-50 disabled:!text-gray-500 !bg-white !transition-colors !duration-200"
        type={type}
        disabled={disabled}
        maxLength={maxLength}
      />
      {suffix && <div className="!absolute !right-3 !top-1/2 !transform !-translate-y-1/2 !text-gray-500 !text-sm">{suffix}</div>}
    </div>
  );
};

export default Input;
